import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Systemuppgifter", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Core", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Weblink", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_messages = _resolveComponent("messages")!
  const _component_import_articles_task = _resolveComponent("import-articles-task")!
  const _component_clear_cache_task = _resolveComponent("clear-cache-task")!
  const _component_weblink_user_sync_task = _resolveComponent("weblink-user-sync-task")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_messages, { ref: "errorHandler" }, null, 512)
    ]),
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_import_articles_task, { class: "mb-3" }),
    _createVNode(_component_clear_cache_task, { class: "mb-3" }),
    _hoisted_4,
    _createVNode(_component_weblink_user_sync_task, { class: "mb-3" })
  ], 64))
}